export const CARD_NUMBER_LOCATOR = "input[data-fieldtype='encryptedCardNumber']";
export const CARD_NUMBER_LABEL_LOCATOR = 'span[data-id="encryptedCardNumber"]';
export const CARD_NUMBER_IFRAME_WRAPPER = 'span[data-cse="encryptedCardNumber"]';

export const CARD_EXPIRY_DATE_LOCATOR = 'input[data-fieldtype="encryptedExpiryDate"]';
export const CARD_EXPIRY_DATE_LABEL_LOCATOR = 'span[data-id="encryptedExpiryDate"]';
export const CARD_EXPIRY_DATE_IFRAME_WRAPPER = 'span[data-cse="encryptedExpiryDate"]';

export const CARD_SECURITY_CODE_LOCATOR = 'input[data-fieldtype="encryptedSecurityCode"]';
export const CARD_SECURITY_CODE_LABEL_LOCATOR = 'span[data-id="encryptedSecurityCode"]';
export const CARD_SECURITY_CODE_IFRAME_WRAPPER = 'span[data-cse="encryptedSecurityCode"]';

export const CARD_HOLDER_NAME_LOCATOR = 'input[name="holderName"]';

export const PAY_BUTTON_LOCATOR = "button.adyen-checkout__button";
export const PAYMENT_STEP_TEST_ID = "payment-step";
export const CANCEL_PENDING_QR_TEST_ID = "cancel-pending-qr";
export const USE_ENTERED_ADDRESS_BUTTON = "use-entered-address-button";

export const PAYMENT_METHOD_SCHEME_LOCATOR = "div.adyen-checkout__payment-method--scheme";
export const SELECTED_PAYMENT_METHOD_LOCATOR = "adyen-checkout__payment-method--selected";
